<h1 mat-dialog-title>Delete file</h1>

<mat-dialog-content>
  <p>Are you sure you want to delete {{fileName}} ?</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="fileName" color="primary">Yes</button>
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
